<template>
  <nut-overlay
    class="preview-image"
    v-model:visible="isShowPreviewImg"
    :z-index="2000"
    :close-on-click-overlay="false"
    @click="setShowPreviewImg"
    :loop="false"
  >
    <div class="wrapper">
      <nut-swiper v-if="isShowPreviewImg && !showPreviewVideo" :is-prevent-default="false"
      :init-page="initPage" auto-play="0">
        <nut-swiper-item
          v-for="(item, index) in list"
          :key="'photo-preview-' + index"
        >
          <div>
            <img :src="item" alt="" style="width: 100%" />
          </div>
        </nut-swiper-item>
      </nut-swiper>
      <nut-video v-else-if="showPreviewVideo == true" :source="source" :options="options"></nut-video>
    </div>
  </nut-overlay>
</template>

<script>
import {defineComponent, reactive, toRefs, watchEffect} from "vue";

export default defineComponent({
  props: {
    showPreviewImg: {
      type: Boolean,
      default: false,
    },
    showPreviewVideo: {
      type: Boolean,
      default: false,
    },
    source: {
      type: Object,
      default: () => {},
    },
    photoList: {
      type: Array,
      default: () => [],
    },
    initPage: {
      type: Number,
      default: 0,
    },
    isViewExample: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const data = reactive({
      isShowPreviewImg: false,
      list: [],
      options: {
        autoplay: true,
        muted: true,
        controls: true
      },
    });
    watchEffect(() => {
      data.isShowPreviewImg = props.showPreviewImg;
      if(props.isViewExample) {
        data.list = props.photoList
      } else {
        props.photoList.forEach(item => {
          data.list.push(item.src)
        })
      }
    });
    const setShowPreviewImg = () => {
      if(props.showPreviewVideo){
        context.emit('setShowPreviewVideo', false)
      }else{
        context.emit('setShowPreviewImg', false)
      }
    }
    return {
      ...toRefs(data),
      setShowPreviewImg,
    };
  },
});
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  :deep(.nut-swiper-inner){
    height: 100% !important;
  }
}
</style>
<style>
.preview-image {
  background-color: rgb(0, 0, 0);
}
</style>
